export enum NOTIFICATION_BAR_TEXT_LIMIT {
  MOBILE = 25,
  TABLET = 75,
  DESKTOP = 120,
  DESKTOP_HIGHRES = 170,
}
